// extracted by mini-css-extract-plugin
export default {"title":"ThirdScreen_title__LFW4K","goldText":"ThirdScreen_goldText__cyA6h","headerSection":"ThirdScreen_headerSection__YG4-3"};